const presentations = (state = {}, action) => {
    switch (action.type) {
        case 'PRESENTATION_DATA_LOADED' : 
            return{
            ...state,
            presentationData : action.payload
            }
        default:
            return state
        }
  }
  export default presentations